import { breakpointsTailwind } from "@vueuse/core";

export function useTheming() {
  const runtimeConfig = useRuntimeConfig();
  const appName = runtimeConfig.public.appName.toLowerCase();
  const route = useRoute();
  const colorMode = useColorMode();
  const isDark = computed(() => colorMode.value === "dark");
  const baseURL = useRuntimeConfig().app.baseURL;
  const breakpoints = useBreakpoints(breakpointsTailwind);
  const largerThanMd = breakpoints.greaterOrEqual("lg");

  const darkLogo = `${baseURL}images/wl/${appName}/logo/dark.png`;
  const lightLogo = `${baseURL}images/wl/${appName}/logo/light.png`;
  const smallLogo = `${baseURL}images/wl/${appName}/logo/small.png`;
  const faviconURL = computed(() => {
    return `${baseURL}images/wl/${appName}/logo/favicon.ico`;
  });

  const currentThemeLogoURL = computed(() => (isDark.value ? lightLogo : darkLogo));

  const outsideLayoutLogoURL = computed(() => {
    const isLightLogo = route.meta.layout === "outside" || (route.path.match(/(login|sign-up)/) && largerThanMd.value);

    return isLightLogo ? lightLogo : isDark.value ? lightLogo : darkLogo;
  });

  const authCoverURL = computed(() => {
    return `${baseURL}images/wl/${appName}/auth/cover.png`;
  });

  const canShowPoweredBy = computed(() => {
    const pixellotApps = ["pixellot", "pixellotadvantage"];

    return !pixellotApps.includes(appName);
  });
  const pixellotLogoURL = computed(() => {
    const darkLogoURL = `${baseURL}images/wl/pixellot/logo/dark.png`;
    const lightLogoURL = `${baseURL}images/wl/pixellot/logo/light.png`;

    return isDark.value ? lightLogoURL : darkLogoURL;
  });

  const helpAndSupportURL = `https://docs.pixellot.tv/portal/en/kb/advantage`;
  const supportURL = `https://you.pixellot.tv/support-center`;
  const edgeIntroDocsURL = `https://docs.pixellot.tv/portal/en/kb/articles/introducing-pixellot-edge`;

  const featureFlagsJSONPath = `static/internal/play-fe-features/${appName}/play-features.json`;
  const fallbackFeatureFlagsJSONPath = `static/internal/play-fe-features/play-features.json`;

  const siteName = computed(() => {
    switch (appName) {
      case "pixellot": return "Pixellot Play";
      case "pixellotadvantage": return "Pixellot Advantage";
      case "pixellotyou": return "Pixellot You";
      case "maxpreps": return "MaxPreps";
      default: return "Pixellot";
    }
  });

  const termsOfServiceURL = computed(() => {
    switch (appName) {
      case "maxpreps": return "https://maxpreps.playonsports.com/advantage-platform-agreement";
      default: return `https://you.pixellot.com/terms-of-use/`;
    }
  });

  const privacyPolicyURL = computed(() => {
    switch (appName) {
      case "maxpreps": return "https://maxpreps.playonsports.com/advantage-privacy-policy";
      default: return `https://you.pixellot.com/privacy-policy/`;
    }
  });

  const companyName = computed(() => {
    switch (appName) {
      case "maxpreps": return "MaxPreps";
      default: return "Pixellot";
    }
  });

  return {
    appName,
    darkLogo,
    lightLogo,
    smallLogo,
    faviconURL,
    canShowPoweredBy,
    pixellotLogoURL,
    helpAndSupportURL,
    termsOfServiceURL,
    privacyPolicyURL,
    supportURL,
    edgeIntroDocsURL,
    currentThemeLogoURL,
    outsideLayoutLogoURL,
    authCoverURL,
    featureFlagsJSONPath,
    fallbackFeatureFlagsJSONPath,
    siteName,
    companyName,
  };
}
